import { cn } from '@/lib/utils';

type CardDescriptionProps = React.ComponentProps<'div'>;

export const CardDescription = ({
  className,
  ...props
}: CardDescriptionProps) => (
  <div
    data-slot="card-description"
    className={cn('tw-text-muted-foreground tw-text-sm', className)}
    {...props}
  />
);
